<template>
  <div class="travel-assistant-wrapper">
    <template v-for="(item, index) in themeLists">
      <ThemeClass :key="index" :title="item.title" :logo="item.logo" v-if="item.list.length > 0">
        <div :class="['theme-card-list', { 'four-style': item.list.length >= 4 }]">
          <ThemeCard
            class="theme-card"
            v-for="(card, idx) in item.list"
            :key="idx"
            :cardInfo="card"
            @themeCardClick="onClickCustomEvent"
          ></ThemeCard>
        </div>
      </ThemeClass>
    </template>
    <!-- 优惠 banner -->
    <WphkBanner :class="['main-banner']" type="swiper" :bannerList="bannerList" :isMultBrow="false" />
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
import WphkBanner, { BannerConfig } from '@tencent/wphk-components-banner';
import { ModuleName } from '@/types/module-type';
import { ThemeList } from '@/types';
import ThemeClass from '@/components/common/theme/theme-class.vue';
import ThemeCard from '@/components/common/theme/theme-card.vue';
import { useConfigStore } from '@/store';

const props = defineProps<{ moduleName: ModuleName }>();

// store
const { getConfig } = useConfigStore();

// banner 列表
const bannerList = ref<BannerConfig[]>();
const themeLists = ref<ThemeList[]>([]);

onBeforeMount(async () => {
  // @ts-ignore
  const { bannerList: bannerListVal, travelTools } = await getConfig(props.moduleName);
  bannerList.value = bannerListVal;
  themeLists.value = travelTools;
});

// 处理自定义事件
function onClickCustomEvent(key: string) {}
</script>

<style lang="less">
@import (reference) '~@/less/main';
.travel-assistant-wrapper {
  .main-banner {
    .banner-container {
      height: auto !important;
    }
    .banner-image {
      width: 686 / @rem;
      height: 120 / @rem;
      border-radius: 8 / @rem;
      display: block;
      margin: auto;
    }
  }
}
</style>

<style lang="less" scoped>
@import '../../../less/theme-card.less';
</style>
